<mat-card class="filter settingHeader">
  <div class="name">
    Manage Form Report Folders
  </div>
  <div class="quickAction">
    <mat-form-field appearance="fill">
      <mat-label>Select</mat-label>
      <mat-select (selectionChange)="OnChange3C($event)" value="1">
        <mat-option value="1">{{CoreShowName}}</mat-option>
        <mat-option value="2">{{ContactShowName}}</mat-option> 
        <mat-option value="3">{{CompanyShowName}}</mat-option>          
      </mat-select>
    </mat-form-field>
    <!-- <mat-form-field appearance="">
      <mat-label>Search items in task status</mat-label>
      <input matInput type="text" [(ngModel)]="value" (keyup)="$event.keyCode == 13 ? Search($event.target.value) : ($event.target.value==''?Search($event.target.value):null)" >
      <button mat-button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
        <mat-icon>close</mat-icon>
      </button>
      <button  *ngIf="!value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field> -->

    <div class="">         
      <button mat-flat-button color="primary" (click)="openDialogAddWithRef(myAddDialog)"> Add Folder </button>
   </div>

  </div>
</mat-card>


<div class="documents">

  <mat-card class="example-list rowholder" *ngIf="!ShowNoRecordFound">
    <div class="fieldRow head">
      <span class="moveicon"></span>
      <span class="fieldName">Folder Name</span>
      <span class="fieldName"></span>     
      <span class="requried">Active/Inactive</span>
      <span class="editField">Edit</span>
      <span class="delete">Delete</span>
    </div>
    <div cdkDropList (cdkDropListDropped)="drop($event)">
    <!-- <div cdkDropList (cdkDropListDropped)="drop($event)"> -->
    <!-- <div class="example-box fieldRow" *ngFor="let task of folderList" cdkDrag> -->
    <div class="example-box fieldRow" *ngFor="let task of folderList" cdkDrag>
      <span class="moveicon"></span>
      <div class="DragIcon" cdkDragHandle>
        <mat-icon>drag_handle</mat-icon>
      </div>
      <span class="fieldName" >{{task.folderName}}
    </span>    
      <ng-container>              
  
        <span class="requried">
          <mat-slide-toggle color="primary" [checked]="task.isActive" (change)="UpdateStatusToggle(task,$event)">
          </mat-slide-toggle>
        </span> 

        <span class="editField">
          <button mat-icon-button class="editbtn" (click)="UpdateTaskDialog(myUpdateDialog,task)">
            <mat-icon>edit</mat-icon>
          </button>
        </span>
  
        <span class="delete">
          <button mat-icon-button class="trash" (click)="deleteFolderForm(task)">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </span>
      </ng-container>

    </div>
    </div>

    
       
  </mat-card>
  <div *ngIf="ShowNoRecordFound" class="noRecordFound">No Record Found</div>

</div>



<ng-template #myAddDialog>
  <form  [formGroup]="formDialog">
  <h2 mat-dialog-title>
      Add Folder Name
      <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
      </button>
  </h2>
  
<mat-dialog-content class="mat-typography">

  <mat-form-field appearance="fill">
    <mat-label>Select</mat-label>
    <mat-select (selectionChange)="OnChange3CAddUpdate($event)" value="1">
      <mat-option value="1">{{CoreShowName}}</mat-option>
      <mat-option value="2">{{ContactShowName}}</mat-option> 
      <mat-option value="3">{{CompanyShowName}}</mat-option>          
    </mat-select>
  </mat-form-field>

  <mat-form-field class="example-full-width">
      <mat-label>Folder Name</mat-label>
      <input matInput [required]="true"  maxlength="50" placeholder="Add folder name" 
      formControlName="foldername"/>
      <mat-error *ngIf="formDialog.get('foldername').invalid &&
        (formDialog.get('foldername').dirty ||
        formDialog.get('foldername').touched)">
      <span>This field is mandatory.</span>
    </mat-error>
    </mat-form-field>
  
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="close()">Cancel</button>
  <button mat-flat-button color="primary" [disabled]="formDialog.invalid || !formDialog.dirty" 
  (click)="AddFolder(formDialog.value)">
  Save
  <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
  </mat-spinner></mat-icon>
</button>
</mat-dialog-actions>
<app-loader></app-loader>
</form>
</ng-template>


<ng-template #myUpdateDialog>
  <form  [formGroup]="updateformDialog">
  <h2 mat-dialog-title>
      Update Folder Name
      <button mat-icon-button (click)="closeUpdate()">
      <mat-icon>close</mat-icon>
      </button>
  </h2>
  
<mat-dialog-content class="mat-typography">
  
  <!-- <mat-form-field appearance="fill">
    <mat-label>Select</mat-label>
    <mat-select (selectionChange)="OnChange3CAddUpdate($event)" value="1">
      <mat-option value="1">{{CoreShowName}}</mat-option>
      <mat-option value="2">{{ContactShowName}}</mat-option> 
      <mat-option value="3">{{CompanyShowName}}</mat-option>          
    </mat-select>
  </mat-form-field> -->

  <mat-form-field class="example-full-width">
      <mat-label>Folder Name</mat-label>
      <input matInput [required]="true"  maxlength="50" placeholder="update folder name" 
      formControlName="foldername"/>
      <mat-error
      *ngIf="updateformDialog.get('foldername').invalid &&
        (updateformDialog.get('foldername').dirty ||
        updateformDialog.get('foldername').touched)">
      <span>This field is mandatory.</span>
    </mat-error>
    </mat-form-field>
   
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="closeUpdate()">Cancel</button>
  <button mat-flat-button color="primary" [disabled]="updateformDialog.invalid || !updateformDialog.dirty" 
  (click)="UpdateFolderName(updateformDialog.value)">
  Update
  <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
  </mat-spinner></mat-icon>
</button>
</mat-dialog-actions>
<app-loader></app-loader>
</form>
</ng-template>








<app-loader></app-loader>